import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/xendora/react-timer/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "api"
    }}>{`API`}</h1>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object (required)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Define your react component here`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`start`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number (required)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A start value for the timer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`end`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`function (required)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A function which determines the end for the timer`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`interval`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An interval value for the timer. Default is 1 second`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onTick`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`function (required)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback function where the next computed value is determined`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onEnd`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A callback function which executes when the timer stops executing`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      